import React from 'react';
import './experiencecard.css';
 
const ExperienceCard = (props) => {
  const isLive = props.status === 'LIVE NOW';
 
  return (
    <div
      className={`experience_card ${props.active ? 'active_card' : ''} ${props.light ? 'light_card' : ''}`}
      style={{ background: props.background }}
    >
      <div className="experience_content">
        <p className="experience_number">{props.number}</p>
        <h3>{props.title}</h3>
        <p className="experience_desc">{props.description}</p>
      </div>
 
      <img
        className="experience_object"
        src={props.image}
        alt=""
      />
 
      <div className={`live_badge ${isLive ? 'badge_live' : 'badge_soon'}`}>
        <span data-gsap-pulse></span>
        <p>{props.status || 'LIVE NOW'}</p>
      </div>
    </div>
  );
};
 
export default ExperienceCard;
